import { getAuth } from 'firebase/auth';

import { withAuthHeader } from '@/lib/backend/api';

import { FIREBASE_TOKEN_KEY } from '../constants';

export const getAuthToken = async () => {
  return (
    (await getAuth().currentUser?.getIdToken()) || localStorage.getItem(FIREBASE_TOKEN_KEY) || ''
  );
};

export const getAuthHeaders = async () => {
  const token = await getAuthToken();
  return withAuthHeader(token);
};
